import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PuebloBase } from '@components/pueblo-base.component';
import { EMPTY_PUEBLO } from '@utils/defaults';

@Component({
  selector: 'pueblo-info-dialog',
  templateUrl: 'pueblo-info-dialog.component.html',
  styleUrl: 'pueblo-info-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PuebloInfoDialog extends PuebloBase {
  readonly $pueblo = input(EMPTY_PUEBLO, {
    alias: 'pueblo',
  });
}
